import type { NextBestProductState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: NextBestProductState = {
  fetchStatus: 'PENDING',
  productIds: [],
};

const store = createSlice({
  name: 'nextBestProduct',
  initialState,
  reducers: {
    setNextBestProductIds: (state, action: PayloadAction<Array<string>>) => {
      state.fetchStatus = 'SUCCESS';
      state.productIds = action.payload;
    },
    setNextBestProductError: (state) => {
      state.fetchStatus = 'ERROR';
      state.productIds = [];
    },
  },
});

export const { setNextBestProductIds, setNextBestProductError } = store.actions;

export default store;
